var map = {
	"./android/Device": 1044,
	"./androidtv/Device": 1252,
	"./arris/Device": 1257,
	"./hisense/Device": 1268,
	"./kepler/Device": 1278,
	"./lg/Device": 1285,
	"./nagra/Device": 1294,
	"./netrange/Device": 1305,
	"./opera/Device": 1313,
	"./polaroid/Device": 1321,
	"./ps4/Device": 1329,
	"./samsung/Device": 1337,
	"./seirobotics/Device": 1345,
	"./sony/Device": 1350,
	"./stbcoship/Device": 1358,
	"./stbcoship9108/Device": 1362,
	"./stbhuawei/Device": 1366,
	"./stbkaon/Device": 1370,
	"./tizen/Device": 1373,
	"./web0s/Device": 1382,
	"./workstation/Device": 665,
	"./workstationChafari/Device": 1396,
	"./zeasn/Device": 1404,
	"./zte/Device": 1412
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1043;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/Device$
// module id = 1043
// module chunks = 0